import { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import userService from "../../Service/user.service";
import { useAuth } from "../../main-component/context/AuthContext";

function EditUserForm() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [user_firstName, setFirstName] = useState("");
  const [user_lastName, setLastName] = useState("");
  const [user_email, setEmail] = useState("");
  const [role_id, setUserRoleId] = useState(1);
  const [roles, setRoles] = useState([]);
  const [serverError, setServerError] = useState("");
  const { user } = useAuth();
  const loggedInUserToken = user?.user_token || "";

  useEffect(() => {
    userService
      .getUserById(id, loggedInUserToken)
      .then((response) => {
        console.log("User fetch response:", response);
        if (response && response.json) {
          return response.json();
        } else {
          throw new Error("Invalid response format");
        }
      })
      .then((data) => {
        if (data.status === "success") {
          const { user_firstName, user_lastName, user_email, role_id } = data.data;
          setFirstName(user_firstName || "");
          setLastName(user_lastName || "");
          setEmail(user_email || "");
          setUserRoleId(role_id || 1);
        } else {
          setServerError(data.error || "Failed to fetch user data");
        }
      })
      .catch((error) => {
        console.error("Error fetching user data:", error);
        setServerError("Failed to fetch user data");
      });

    fetchRoles(loggedInUserToken);
  }, [id, loggedInUserToken]);

  const fetchRoles = (token) => {
    userService
      .getRoles(token)
      .then((response) => {
        console.log("Roles fetch response:", response);
        if (response && response.json) {
          return response.json();
        } else {
          throw new Error("Invalid response format");
        }
      })
      .then((data) => {
        if (data.status === "success") {
          const rolesData = data.data || [];
          setRoles(rolesData);
          console.log(roles);
        } else {
          setServerError(data.error || "Failed to fetch roles");
        }
      })
      .catch((error) => {
        console.error("Error fetching roles:", error);
        setServerError("Failed to fetch roles");
      });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const formData = {
      user_firstName,
      user_lastName,
      user_email,
      role_id,
    };

    userService
      .updateUser(id, formData, loggedInUserToken)
      .then((response) => {
        console.log("Update user response:", response);
        if (response && response.json) {
          return response.json();
        } else {
          throw new Error("Invalid response format");
        }
      })
      .then((data) => {
        if (data.status === "success") {
          setServerError("");
          navigate("/d2f4b9a1-7c38-4d7e-ae1e-938b33d8b75e/user");
        } else {
          setServerError(data.error || "Failed to update user");
        }
      })
      .catch((error) => {
        console.error("Error updating user:", error);
        setServerError("Failed to update user");
      });
  };

  return (
    <section className="py-5 bg-light">
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-lg-8">
            <div className="card shadow">
              <div className="card-body">
                <h2 className="card-title text-center mb-4">Edit User</h2>
                
                <form onSubmit={handleSubmit}>
                  {serverError && (
                    <div className="alert alert-danger">{serverError}</div>
                  )}

                  {/* Email Field */}
                  <div className="mb-3">
                    <label htmlFor="user_email" className="form-label">User Email</label>
                    <input
                      type="email"
                      id="user_email"
                      name="user_email"
                      value={user_email}
                      onChange={(e) => setEmail(e.target.value)}
                      placeholder="Enter user email"
                      className="form-control"
                    />
                  </div>

                  {/* First Name Field */}
                  <div className="mb-3">
                    <label htmlFor="user_firstName" className="form-label">First Name</label>
                    <input
                      type="text"
                      id="user_firstName"
                      name="user_firstName"
                      value={user_firstName}
                      onChange={(e) => setFirstName(e.target.value)}
                      placeholder="Enter first name"
                      className="form-control"
                    />
                  </div>

                  {/* Last Name Field */}
                  <div className="mb-3">
                    <label htmlFor="user_lastName" className="form-label">Last Name</label>
                    <input
                      type="text"
                      id="user_lastName"
                      name="user_lastName"
                      value={user_lastName}
                      onChange={(e) => setLastName(e.target.value)}
                      placeholder="Enter last name"
                      className="form-control"
                    />
                  </div>

                  {/* Role Select Field */}
                  <div className="mb-4">
                    <label htmlFor="user_role_id" className="form-label">Role</label>
                    <select
                      id="user_role_id"
                      name="user_role_id"
                      value={role_id}
                      onChange={(e) => setUserRoleId(Number(e.target.value))}
                      className="form-select"
                    >
                      {roles.length > 0 ? (
                        roles.map((role) => (
                          <option key={role.role_id} value={role.role_id}>
                            {role.Company_role}
                          </option>
                        ))
                      ) : (
                        <option value="">No roles available</option>
                      )}
                    </select>
                  </div>

                  {/* Submit Button */}
                  <div className="d-grid">
                    <button
                      type="submit"
                      className="btn btn-primary"
                    >
                      Update User
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default EditUserForm;